import { useParams } from 'react-router';
import { Oval } from 'react-loader-spinner';
import { useCancelSubscriptionQuery } from '../store/apiSlice';

function CancelSubscriptionPage() {
  const { cancelToken } = useParams();
  const { data, isLoading, error } = useCancelSubscriptionQuery(cancelToken);

  if (isLoading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center">
        <Oval
          visible={true}
          height={50}
          width={50}
          color="#a99cdf"
          strokeWidth="3"
          strokeWidthSecondary="3"
          secondaryColor="#e2e6ff"
          ariaLabel="oval-loading"
        />
      </div>
    );
  }

  if (error || data?.error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-5">
        <h4 className="color-error">Oops! Something went wrong</h4>
        <p>{error?.data?.error || data?.error || "Unable to cancel your subscription."}</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5">
      <h4 className="color-secondary">Subscription Cancelled</h4>
      <p>Your subscription was successfully cancelled</p>
    </div>
  );
}

export default CancelSubscriptionPage;
